export const menu = [
  { title: "How does this app work?", id: "index-0", desc: "html", children: [] },
  {
    title: "Intents",
    id: "index-1",
    desc: "html",
    children: [
      { title: "Change Address", id: "index-1-0", desc: "html" },
      { title: "Order Cancel", id: "index-1-1", desc: "html" },
      { title: "Tracking Inquiry", id: "index-1-2", desc: "html" },
      { title: "Product Faulty", id: "index-1-3", desc: "html" },
      { title: "Missing Parts", id: "index-1-4", desc: "html" },
      { title: "Others", id: "index-1-5", desc: "html" },
    ],
  },
  {
    title: "Setting Up Template",
    id: "index-2",
    desc: "html",
    children: [
      { title: "Additional Tag", id: "index-2-0", desc: "html" },
      { title: "Tag to Zendesk", id: "index-2-1", desc: "html" },
      { title: "Allow Auto Reply", id: "index-2-2", desc: "html" },
      { title: "Confidence Score", id: "index-2-3", desc: "html" },
      { title: "Auto Reply Content", id: "index-2-4", desc: "html" },
      { title: "Activate Template", id: "index-2-5", desc: "html" },
    ],
  },
  {
    title: "App Errors",
    id: "index-8",
    desc: "html",
    children: [
      { title: "An error occurred", id: "index-8-0", desc: "html" },
      { title: "No detectable intent", id: "index-8-1", desc: "html" },
      { title: "If a ticket has already been replied to by the app", id: "index-8-2", desc: "html" },
      { title: "Multiple comments from customer is received", id: "index-8-3", desc: "html" },
      { title: "When the app is not authorized or subscription has run out", id: "index-8-4", desc: "html" },
    ],
  },
  {
    title: "FAQ",
    id: "index-9",
    desc: "html",
    children: [
      { title: "What does the AI Ticket Reply by New Aim app do?", id: "index-9-0", desc: "html" },
      { title: "How does the app determine the ticket intent?", id: "index-9-1", desc: "html" },
      { title: "How to Install AI Ticket Reply by New Aim app?", id: "index-9-2", desc: "html" },
      { title: "How to Authorize API Access for AI Ticket Reply by New Aim?", id: "index-9-3", desc: "html" },
      { title: "How to Uninstall AI Ticket Reply by New Aim app?", id: "index-9-4", desc: "html" },
      { title: "Can I add new intents?", id: "index-9-5", desc: "html" },
      { title: "Which tickets can AI Ticket Reply by New Aim app help me with?", id: "index-9-6", desc: "html" },
      {
        title: "What happens if the customer sends multiple replies within a very short amount of time?",
        id: "index-9-7",
        desc: "html",
      },
    ],
  },
];
